import React from "react";

import { IAppInfo } from "infrastructure";
import { IAppRouteProps } from "ui/app/navigation";

export interface IAppContext {
  appInfo: IAppInfo;
  applyTheme: (theme: string) => void;
  routes: IAppRouteProps[];
}

export const AppContext = React.createContext<IAppContext>({} as any);

export interface IAppRootProps {
  appInfo: IAppInfo;
  applyTheme: (theme: string) => void;
  routes: IAppRouteProps[];
}

export const AppRoot: React.FC<IAppRootProps> = ({ appInfo, applyTheme, routes, children }) => {
  return (
    <AppContext.Provider
      value={{
        appInfo: appInfo,
        applyTheme: applyTheme,
        routes: routes
      }}
    >
      {children}
    </AppContext.Provider>
  );
};
